/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
function cartCount(){ 
  $.getJSON('/cart.js', function(cart) { 
    if (cart.item_count >= 9){
      $("[data-cart-toggle] .header__cart__status").text('9+'); 
    }else{
    $("[data-cart-toggle] .header__cart__status").text(cart.item_count);   
    }
    
    if(cart.item_count == 0){ $('[data-cart-toggle] .header__cart__status').hide(); } else{ $('[data-cart-toggle] .header__cart__status').css('display', 'inline-flex'); }
  });
}
function openDrawer(currentThis){
  // $.ajax({
  //   type: "GET", 
  //   url: "/",
  //   dataType: 'html',
  //   success: function(data){
  //     // var miniCartHead = $('.cdk_hidden_html').html(data).find("#cart-drawer").html();
  //     // $('#cart-drawer').html(miniCartHead);
  //     $('#cart-drawer').html($(data).find('#cart-drawer').html());
  //     // console.log(miniCartHead);
  //   }
  // })
 $.ajax({
    url: '/',
   dataType: 'html',
    success: function(response) {
       $('#cart-drawer').removeClass('is-empty');
        var updatedCartDrawer = $(response).find('#rb-drawer').html();
        $('#rb-drawer').html(updatedCartDrawer);
      $('.cart-block').addClass('is-animated');
      $('.cart__item').addClass('is-animated');
        console.log(updatedCartDrawer);
    }
});

}

  function updateCartWithItems(cartData) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update endpoint
      data: {
        updates: cartData,
      },
      dataType: 'json',
      success: function (cart) {
        //console.log('Cart updated successfully:', cart);
        cartCount()
        openDrawer() 
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error('Error updating cart:', errorThrown);
        // Handle the error, if any.
      },
    });
  }

function ajaxAddToCartProduct(currentThis,dynamicData) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      cartCount();
      
      setTimeout(function () {
        openDrawer();
        $('#cart-drawer').addClass('is-open custom_cart_btns');
      },1000);
      
      // setTimeout(function () {
      //   $('#cart-drawer .drawer__inner').find('*').addClass('is-animated');
      //   $('body').css({'overflow':'hidden', 'padding-right': '17px'});
      // },2500);
            
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

$(document).ready(function(){
  // bundle option selected js
  $(document).mouseup(function (e) {
    if ($(e.target).closest(".swatches-block-box").length === 0) {
        $(".swatches-block .option_label").removeClass('active');
        $(".swatches-block-box").removeClass('open');
    }
  });
  var lopchk = 0;
  $(document).on('click','.bundle-product-option .swatches-block .option_label:not(.active)', function () {
    if(lopchk == 0){
    $(this).addClass('active');
    $(this).next('.swatches-block-box').addClass('open');
      lopchk = lopchk + 1;
    }else{
     lopchk = 0;
    }
  })
  $(document).on('click','.bundle-product-option .swatches-block .option_label.active', function () {
    if(lopchk == 0){
    $(this).removeClass('active');
    $(this).next('.swatches-block-box').removeClass('open');
    lopchk = lopchk + 1;
    }else{
     lopchk = 0;
    }
  })
  $(document).on('click','.bundle-product-option .swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    $(this).parents('.swatches-block-box').removeClass('open');
    $(this).parents('.swatches-block').find(".option_label").removeClass('active');
    $(this).parents('.swatches-block').find('.option_label .color_name_indicator').text(OptionName);
    // console.log("OptionName::"+OptionName);
  })

  $(document).on('change','.swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    console.log('thisParentId::'+thisParentId);
    $('.product-swatches[data-id="'+thisParentId+'"] .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
      // console.log('selectVal::'+selectVal);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    // console.log('newstr::'+newstr);     
    var optionName_Selector = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]');
    var optionName_val = optionName_Selector.val(); 
    $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change(); 
  });
  $(document).on('change','.product-swatches select.product_card-form__master-select', function () {
    var thisMainVal = $(this).val(); 
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    // console.log('thisMainVal::'+thisMainVal);
    var ThisSellingPlan = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val();
    // console.log('ThisSellingPlan::'+ThisSellingPlan);
    var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
    // console.log('ThisProdAvail::'+ThisProdAvail);
  // $('.cdk-add-bundle').attr('data-variant', thisMainVal).attr('data-sellingplan',ThisSellingPlan);
      
    var thisMainVal1 = $('.bundle-product-one select.product_card-form__master-select').val(); 
    var ThisProdAvail1 =$('.bundle-product-one select.product_card-form__master-select').find('option[value="'+thisMainVal1+'"]').attr('data-varaint-availability');
    var thisMainVal2 = $('.bundle-product-second select.product_card-form__master-select').val(); 
    var ThisProdAvail2 =$('.bundle-product-second select.product_card-form__master-select').find('option[value="'+thisMainVal2+'"]').attr('data-varaint-availability');
    
    // console.log('thisMainVal1::'+ thisMainVal1);
    // console.log('ThisProdAvail1::'+ ThisProdAvail1);
    // console.log('thisMainVal2::'+ thisMainVal2);
    //  console.log('ThisProdAvail2::'+ ThisProdAvail2);
    
    if (ThisProdAvail1 == 'true' && ThisProdAvail2 == 'true'){
      $('.form__wrapper').removeClass('variant--soldout');
       $('.cdk-add-bundle').removeClass('disable');
      $('.cdk-add-bundle').find('.btn_text').text('add to bag');
    }else{ 
      $('.form__wrapper').addClass('variant--soldout');
      $('.cdk-add-bundle').addClass('disable');
      $('.cdk-add-bundle').find('.btn_text').text('sold out');
    }   
  });

  $(document).on('click','.cdk-add-bundle', function(event){ 
    event.preventDefault();
    var quantity = $('.QuantitySelector__CurrentQuantity').val();
    var currentThis = $(this);
    var updateItems = [];
    $(this).parents('.product__content ').find('.bundle-product-option').each(function(){
      var thisParentId = $(this).children('.product-swatches').attr('data-id');
      var thisId = $(this).children('.product-swatches[data-id="'+thisParentId+'"]').find('select.product_card-form__master-select').val();
      // console.log('thisId::'+ thisId); 
      updateItems.push({ "id": thisId, "quantity": quantity });
    })
    ajaxAddToCartProduct(currentThis,updateItems);
    
  });
 var thisMainVal1 = $('.bundle-product-one select.product_card-form__master-select').val(); 
  var ThisProdAvail1 =$('.bundle-product-one select.product_card-form__master-select').find('option[value="'+thisMainVal1+'"]').attr('data-varaint-availability');
  var thisMainVal2 = $('.bundle-product-second select.product_card-form__master-select').val(); 
  var ThisProdAvail2 =$('.bundle-product-second select.product_card-form__master-select').find('option[value="'+thisMainVal2+'"]').attr('data-varaint-availability');

    // console.log('thisMainVal1::'+ thisMainVal1);
    // console.log('ThisProdAvail1::'+ ThisProdAvail1);
    // console.log('thisMainVal2::'+ thisMainVal2);
    // console.log('ThisProdAvail2::'+ ThisProdAvail2);
  if (ThisProdAvail1 == 'true' && ThisProdAvail2 == 'true'){
    $('.form__wrapper').removeClass('variant--soldout');
     $('.cdk-add-bundle').removeClass('disable');
     $('.cdk-add-bundle').find('.btn_text').text('add to bag');
    var pd_price = $('.cdk-add-bundle').attr('data-price');
     $('.cdk-add-bundle').find('.btn_text').append('<span class="bt-pric">' + pd_price + '</span>');
    $('.cdk-add-bundle').attr('data-btn', 'Add To Cart' );
  }else{ 
    $('.cdk-add-bundle').addClass('disable');
    $('.form__wrapper').addClass('variant--soldout');
    $('.cdk-add-bundle').find('.btn_text').text('sold out');
    $('.cdk-add-bundle').attr('data-btn', 'soldout' );
  }


  $(document).on('click', '.custom_cart_btns .cart__quantity-plus', function (ev) {
    ev.preventDefault(); 
    var updatedCartData = {};
    $(this).parents('.drawer__body').addClass('loading');
     var qtySelector = $(this).parents('.cart__quantity').find('input.cart__quantity-field');
    var thisVarId = $(this).parents('.cart__quantity').find('input.cart__quantity-field').attr('data-id');
      var qtyval  = parseInt(qtySelector.val());    
    console.log('qtyval::'+qtyval);
      // var qtyval = qtyval + 1;  
    console.log('thisVarId::'+thisVarId)
     $(qtySelector).val(qtyval);
      // Store the updated quantity in updatedCartData
    updatedCartData[thisVarId] = qtyval;

    // Call a function to update the cart with the new quantity and variant ID
    updateCartWithItems(updatedCartData);
  })

    $(document).on('click', '.custom_cart_btns .cart__quantity-minus', function (ev) {
    ev.preventDefault(); 
    var updatedCartData = {};
    $(this).parents('.drawer__body').addClass('loading');
     var qtySelector = $(this).parents('.cart__quantity').find('input.cart__quantity-field');
      var thisVarId = $(this).parents('.cart__quantity').find('input.cart__quantity-field').attr('data-id');
      var qtyval = parseInt(qtySelector.val());    
      // var qtyval = qtyval - 1; 
      console.log('qtyval::'+qtyval);
     $(qtySelector).val(qtyval);
      console.log('thisVarId::'+thisVarId)
      console.log('qtyval::'+qtyval)
       // Store the updated quantity in updatedCartData
    updatedCartData[thisVarId] = qtyval;

    // Call a function to update the cart with the new quantity and variant ID
    updateCartWithItems(updatedCartData);
  })

    $(document).on('click', '.custom_cart_btns .cart__item__remove', function (ev) {
    ev.preventDefault(); 
    var updatedCartData = {};     
      $(this).parents('.drawer__body').addClass('loading');
      var thisVarId = $(this).attr('data-id');
      var qtyval = 0;    
       // Store the updated quantity in updatedCartData
    updatedCartData[thisVarId] = qtyval;

    // Call a function to update the cart with the new quantity and variant ID
    updateCartWithItems(updatedCartData);
  })
 $(document).on('click', '.custom_cart_btns span.drawer__underlay, .custom_cart_btns button.drawer__close', function () {
     $('#cart-drawer').removeClass('is-open');
  })

  
});

document.addEventListener('DOMContentLoaded', function() {
  var mainSearches = document.querySelectorAll('main-search');
  mainSearches.forEach(function(search) {
    search.scrollIntoView = function() {
      // Do nothing to prevent the mobile screen jump
    };
  });

  // Prevent GridSlider from destroying arrows on mobile touch devices
  const GridSlider = customElements.get('grid-slider');
  if (GridSlider) {
    const originalToggleSlider = GridSlider.prototype.toggleSlider;
    
    GridSlider.prototype.toggleSlider = function() {
      const originalTouch = window.theme && window.theme.touch;
      // Temporarily set touch to false to bypass the destruction logic
      if (window.theme) {
        window.theme.touch = false;
      }
      
      originalToggleSlider.call(this);
      
      if (window.theme) {
        window.theme.touch = originalTouch;
      }
    };

    function patchSlider(slider) {
      if (slider.dataset.mobilePatchBound) return;
      slider.dataset.mobilePatchBound = 'true';
      if (typeof slider.toggleSlider === 'function') {
        document.removeEventListener('theme:resize:width', slider.toggleSlider);
        slider.toggleSlider = GridSlider.prototype.toggleSlider.bind(slider);
        document.addEventListener('theme:resize:width', slider.toggleSlider);
        slider.buttons = [];
        slider.toggleSlider();
      }
    }

    // Patch existing sliders
    document.querySelectorAll('grid-slider').forEach(patchSlider);

    // Watch for async-injected sliders (e.g. related products, recently viewed)
    var sliderObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'GRID-SLIDER') {
            patchSlider(node);
          } else {
            node.querySelectorAll && node.querySelectorAll('grid-slider').forEach(patchSlider);
          }
        });
      });
    });
    sliderObserver.observe(document.body, { childList: true, subtree: true });
  }
});

// ===== Upsell Slider Arrows =====
(function() {
  function initUpsellArrows() {
    document.querySelectorAll('.upsell-slider-wrapper').forEach(function(wrapper) {
      if (wrapper.dataset.arrowsBound) return;
      wrapper.dataset.arrowsBound = 'true';

      var track = wrapper.querySelector('.cart-upsell__track');
      var btnPrev = wrapper.querySelector('.upsell-slider-btn--prev');
      var btnNext = wrapper.querySelector('.upsell-slider-btn--next');

      if (!track || !btnPrev || !btnNext) return;

      function getScrollAmount() {
        var firstCard = track.querySelector('.product-upsell, [data-quick-add-holder]');
        return firstCard ? firstCard.offsetWidth + 12 : 180;
      }

      function getLastCardTarget() {
        var cards = track.querySelectorAll('.product-upsell, [data-quick-add-holder]');
        if (!cards.length) return track.scrollWidth - track.clientWidth;
        var lastCard = cards[cards.length - 1];
        return Math.max(0, (lastCard.offsetLeft + lastCard.offsetWidth) - track.clientWidth);
      }

      function updateButtons() {
        if (track.clientWidth === 0) return;
        var atStart = track.scrollLeft <= 2;
        var lastTarget = getLastCardTarget();
        var atEnd = Math.ceil(track.scrollLeft) >= lastTarget - 5;
        if (track.scrollWidth <= track.clientWidth) {
          atStart = true;
          atEnd = true;
        }
        btnPrev.classList.toggle('is-disabled', atStart);
        btnNext.classList.toggle('is-disabled', atEnd);
      }

      function smoothScroll(track, amount, target) {
        if (target !== undefined) {
          track.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        }
      }

      btnPrev.addEventListener('click', function() {
        var amount = getScrollAmount();
        if (track.scrollLeft <= amount) {
          smoothScroll(track, null, 0);
        } else {
          smoothScroll(track, -amount);
        }
      });

      btnNext.addEventListener('click', function() {
        var amount = getScrollAmount();
        var lastTarget = getLastCardTarget();
        if (track.scrollLeft + amount >= lastTarget - 10) {
          smoothScroll(track, null, lastTarget);
        } else {
          smoothScroll(track, amount);
        }
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      
      // Wait for content to load before checking button states
      // setTimeout(updateButtons, 300);
      setTimeout(updateButtons, 800);

      // Re-check after dynamic content loads into the track
      var trackObserver = new MutationObserver(function() {
        setTimeout(updateButtons, 100);
      });
      trackObserver.observe(track, { childList: true, subtree: false });

      if (window.ResizeObserver) {
        new ResizeObserver(function() {
          updateButtons();
        }).observe(track);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initUpsellArrows);

  document.addEventListener('theme:cart:change', function() {
    document.querySelectorAll('.upsell-slider-wrapper').forEach(function(w) {
      delete w.dataset.arrowsBound;
    });
    setTimeout(initUpsellArrows, 400);
  });

  // Observe DOM for dynamically injected wrappers (recommendations slider)
  var globalObserver = new MutationObserver(function() {
    var unbound = document.querySelectorAll('.upsell-slider-wrapper:not([data-arrows-bound])');
    if (unbound.length) initUpsellArrows();
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });
})();

// ===== Collection Block Slider Arrows =====
(function() {
  function initColArrows() {
    if (window.innerWidth >= 750) return;
    
    document.querySelectorAll('.col-slider-wrapper').forEach(function(wrapper) {
      if (wrapper.dataset.arrowsBound) return;
      wrapper.dataset.arrowsBound = 'true';

      var track = wrapper.querySelector('.grid--mobile-slider');
      var btnPrev = wrapper.querySelector('.col-slider-btn--prev');
      var btnNext = wrapper.querySelector('.col-slider-btn--next');

      if (!track || !btnPrev || !btnNext) return;

      function getScrollAmount() {
        var firstCard = track.querySelector('.grid-item');
        return firstCard ? firstCard.offsetWidth + 12 : 180;
      }

      function getLastCardTarget() {
        var cards = track.querySelectorAll('.grid-item');
        if (!cards.length) return track.scrollWidth - track.clientWidth;
        var lastCard = cards[cards.length - 1];
        return Math.max(0, (lastCard.offsetLeft + lastCard.offsetWidth) - track.clientWidth);
      }

      function updateButtons() {
        if (track.clientWidth === 0) return;
        var atStart = track.scrollLeft <= 2;
        var lastTarget = getLastCardTarget();
        var atEnd = Math.ceil(track.scrollLeft) >= lastTarget - 5;
        if (track.scrollWidth <= track.clientWidth) {
          atStart = true;
          atEnd = true;
        }
        btnPrev.classList.toggle('is-disabled', atStart);
        btnNext.classList.toggle('is-disabled', atEnd);
      }

      function smoothScroll(track, amount, target) {
        if (target !== undefined) {
          track.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        }
      }

      btnPrev.addEventListener('click', function() {
        var amount = getScrollAmount();
        if (track.scrollLeft <= amount) {
          smoothScroll(track, null, 0);
        } else {
          smoothScroll(track, -amount);
        }
      });

      btnNext.addEventListener('click', function() {
        var amount = getScrollAmount();
        var lastTarget = getLastCardTarget();
        if (track.scrollLeft + amount >= lastTarget - 10) {
          smoothScroll(track, null, lastTarget);
        } else {
          smoothScroll(track, amount);
        }
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      setTimeout(updateButtons, 300);
      setTimeout(updateButtons, 800);
      
      if (window.ResizeObserver) {
        new ResizeObserver(function() {
          updateButtons();
        }).observe(track);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initColArrows);
  window.addEventListener('resize', initColArrows);
})();

(function () {
  var FAB_STYLE_ID = 'bl-cookie-bottom-override';
  var COOKIE_CSS = [
    'button[aria-label="Cookie settings"] {',
    '  bottom: var(--bl-fab-visual-bottom, 18px) !important;',
    '  transition: bottom 0.3s ease !important;',
    '  --duration: 0s;',
    '}',
    ':host(.bl-cookie-hiding) button[aria-label="Cookie settings"] {',
    '  opacity: 0 !important;',
    '  pointer-events: none !important;',
    '}'
  ].join('');

  function getCookieHost() {
    return document.querySelector('pandectes-cmp');
  }

  function getCookieLauncher(shadow) {
    return shadow && shadow.querySelector('button[aria-label="Cookie settings"]');
  }

  function cookieDialogOpen(shadow) {
    if (!shadow) return false;
    var dialog = shadow.querySelector('dialog');
    if (!dialog) return false;
    return dialog.open || dialog.hasAttribute('open');
  }

  function ensureCookieStyle(shadow) {
    if (!shadow) return;
    var style = shadow.getElementById(FAB_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = FAB_STYLE_ID;
      shadow.appendChild(style);
    }
    if (style.textContent !== COOKIE_CSS) style.textContent = COOKIE_CSS;
  }

  function findChatNudge() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return null;
    function walk(root, depth) {
      if (!root || depth > 5) return null;
      var n = root.querySelector('.activator-nudge');
      if (n) return n;
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].shadowRoot) {
          var found = walk(nodes[i].shadowRoot, depth + 1);
          if (found) return found;
        }
      }
      return null;
    }
    return walk(chat.shadowRoot, 0);
  }

  var syncing = false;
  var syncRaf = 0;

  function scheduleSync() {
    if (syncRaf) return;
    syncRaf = window.requestAnimationFrame(function () {
      syncRaf = 0;
      syncFabs();
    });
  }

  function syncFabs() {
    if (syncing) return false;
    syncing = true;

    var bar = document.querySelector('.bl-sticky-bar.bl-sticky-visible');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--bl-sticky-h', h + 'px');

    var nudge = findChatNudge();
    if (nudge) {
      var nb = parseFloat(window.getComputedStyle(nudge).bottom);
      if (!isNaN(nb)) {
        document.documentElement.style.setProperty('--bl-chat-nudge', nb + 'px');
      }
    }

    var host = getCookieHost();
    var shadow = host && host.shadowRoot;
    if (!host || !shadow) {
      syncing = false;
      return false;
    }
    ensureCookieStyle(shadow);
    host.classList.toggle('bl-sticky-raised', !!bar);

    var cookieBtn = getCookieLauncher(shadow);
    if (cookieBtn) {
      cookieBtn.classList.remove('bottom-9');
      var visual = h ? h + 12 : 18;
      cookieBtn.style.setProperty('bottom', visual + 'px', 'important');
    }

    syncing = false;
    return !!cookieBtn;
  }

  window.blSyncFabs = syncFabs;

  function hideCookieLauncher(host, btn) {
    host.classList.add('bl-cookie-hiding');
    if (btn) {
      btn.style.setProperty('opacity', '0', 'important');
      btn.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function showCookieLauncher(host) {
    var btn = getCookieLauncher(host.shadowRoot);
    syncFabs();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (btn) {
          btn.style.removeProperty('opacity');
          btn.style.removeProperty('pointer-events');
        }
        host.classList.remove('bl-cookie-hiding');
      });
    });
  }

  var revealTimer;
  function revealCookieAfterJump(host) {
    clearTimeout(revealTimer);
    var sawOpen = false;
    var tries = 0;
    function attempt() {
      var shadow = host.shadowRoot;
      var dialogOpen = cookieDialogOpen(shadow);
      var btn = getCookieLauncher(shadow);
      if (dialogOpen) sawOpen = true;
      if (sawOpen && !dialogOpen && btn) {
        showCookieLauncher(host);
        return;
      }
      if (!host.classList.contains('bl-cookie-hiding')) return;
      if (++tries < 200) {
        revealTimer = setTimeout(attempt, 50);
      } else {
        host.classList.remove('bl-cookie-hiding');
      }
    }
    revealTimer = setTimeout(attempt, 50);
  }

  function bindCookieEvents(host, shadow) {
    if (!host || host.dataset.blCookieBound === '1') return;
    host.dataset.blCookieBound = '1';

    shadow.addEventListener('click', function (e) {
      var launcher = e.target.closest && e.target.closest('button[aria-label="Cookie settings"]');
      if (launcher) {
        ensureCookieStyle(shadow);
        hideCookieLauncher(host, launcher);
        revealCookieAfterJump(host);
        return;
      }

      setTimeout(function () {
        if (!host.classList.contains('bl-cookie-hiding')) syncFabs();
      }, 80);
    }, true);
  }

  function watchCookie() {
    var host = getCookieHost();
    var shadow = host && host.shadowRoot;
    if (!host || !shadow) return false;
    bindCookieEvents(host, shadow);
    return syncFabs();
  }

  function watchStickyBar() {
    var bar = document.querySelector('.bl-sticky-bar');
    if (!bar || bar.dataset.blFabObserved === '1') return;
    bar.dataset.blFabObserved = '1';
    if (window.ResizeObserver) {
      new ResizeObserver(function () { scheduleSync(); }).observe(bar);
    }
    new MutationObserver(function () { scheduleSync(); }).observe(bar, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  var CHAT_BACKDROP_CSS = [
    '@media (max-width: 749px) {',
    '  .backdrop {',
    '    position: fixed !important;',
    '    top: 0 !important;',
    '    left: 0 !important;',
    '    width: 100vw !important;',
    '    max-width: none !important;',
    '    height: 100dvh !important;',
    '    margin: 0 !important;',
    '    right: auto !important;',
    '  }',
    '}'
  ].join('');

  var boundChatShadows = typeof WeakSet === 'function' ? new WeakSet() : null;

  function getChatRuntimeShadow() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return null;
    var runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot ? runtime.shadowRoot : null;
  }

  function injectChatBackdropStyle() {
    var shadow = getChatRuntimeShadow();
    if (!shadow) return false;
    if (shadow.getElementById('bl-chat-backdrop-fix')) return true;
    var style = document.createElement('style');
    style.id = 'bl-chat-backdrop-fix';
    style.textContent = CHAT_BACKDROP_CSS;
    shadow.appendChild(style);
    return true;
  }

  function bindChatShadowWatchers(chat) {
    if (chat.dataset.blChatShadowBound === '1') return;
    chat.dataset.blChatShadowBound = '1';

    function onChatTreeChange() {
      if (chat.shadowRoot && chat.dataset.blOuterShadowBound !== '1') {
        chat.dataset.blOuterShadowBound = '1';
        new MutationObserver(function () {
          injectChatBackdropStyle();
          bindRuntimeShadowObserver(chat);
        }).observe(chat.shadowRoot, { childList: true, subtree: true });
      }
      injectChatBackdropStyle();
      bindRuntimeShadowObserver(chat);
    }

    new MutationObserver(onChatTreeChange).observe(chat, {
      attributes: true,
      childList: true
    });
    onChatTreeChange();
  }

  function bindRuntimeShadowObserver(chat) {
    var shadow = getChatRuntimeShadow();
    if (!shadow) return;
    if (boundChatShadows && !boundChatShadows.has(shadow)) {
      boundChatShadows.add(shadow);
      new MutationObserver(function () { injectChatBackdropStyle(); }).observe(shadow, {
        childList: true,
        subtree: true
      });
    }
    injectChatBackdropStyle();
  }

  function watchChatHost() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return false;
    if (chat.dataset.blFabObserved !== '1') {
      chat.dataset.blFabObserved = '1';
      if (window.ResizeObserver) {
        new ResizeObserver(function () { scheduleSync(); }).observe(chat);
      }
    }
    bindChatShadowWatchers(chat);
    bindRuntimeShadowObserver(chat);
    return injectChatBackdropStyle();
  }

  function watchForChatElement() {
    if (watchChatHost()) return;
    var obs = new MutationObserver(function () {
      if (watchChatHost()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initFabs() {
    watchStickyBar();
    watchForChatElement();
    var cookieOk = watchCookie();
    var chatOk = watchChatHost();
    if (cookieOk && chatOk) return;
    var tries = 0;
    var timer = setInterval(function () {
      watchStickyBar();
      if (watchCookie()) cookieOk = true;
      if (watchChatHost()) chatOk = true;
      if ((cookieOk && chatOk) || ++tries > 50) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFabs);
  } else {
    initFabs();
  }

  window.addEventListener('resize', scheduleSync);
  window.addEventListener('orientationchange', scheduleSync);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSync);
    window.visualViewport.addEventListener('scroll', scheduleSync);
  }
})();


// Safari fix: Prevent DraggableSlider from activating 'is-dragging' (grabbing cursor
// and pointer-events: none) on click/tap. Only genuine drag movement (>8px) will
// be allowed through to DraggableSlider.handleMouseMove.
(function () {
  var sx = 0, sy = 0;
  var isDown = false;
  var wasDragging = false;
  var activeSlider = null;
  var DRAG_THRESHOLD = 8;

  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    activeSlider = e.target.closest('.grid--slider, .grid--mobile-slider, [data-grid-slider]');
    if (!activeSlider) return;

    sx = e.clientX;
    sy = e.clientY;
    isDown = true;
    wasDragging = false;
    activeSlider.classList.remove('is-dragging');
  }, true);

  document.addEventListener('mousemove', function (e) {
    if (!isDown || !activeSlider) return;

    if (!wasDragging) {
      var dx = Math.abs(e.clientX - sx);
      var dy = Math.abs(e.clientY - sy);
      if (dx <= DRAG_THRESHOLD && dy <= DRAG_THRESHOLD) {
        e.stopImmediatePropagation();
        return;
      }
      wasDragging = true;
    }
  }, true);

  document.addEventListener('mouseup', function () {
    isDown = false;
    setTimeout(function () {
      wasDragging = false;
      activeSlider = null;
    }, 100);
  }, true);

  // If genuine dragging occurred, suppress accidental link click on mouseup
  document.addEventListener('click', function (e) {
    if (wasDragging) {
      e.preventDefault();
      e.stopImmediatePropagation();
      wasDragging = false;
    }
  }, true);
})();

// Save cart note functionality
document.addEventListener('click', function(e) {
  if (e.target && e.target.id === 'save-cart-note-btn') {
    e.preventDefault();
    var noteField = document.getElementById('note');
    if (noteField) {
      var noteValue = noteField.value;
      var btn = e.target;
      var originalText = btn.textContent;
      btn.textContent = 'Saving...';
      btn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ note: noteValue })
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        btn.textContent = 'Saved';
        btn.disabled = false;
        setTimeout(function() {
          btn.textContent = originalText;
        }, 2000);
      })
      .catch(function(error) {
        console.error('Error saving note:', error);
        btn.textContent = originalText;
        btn.disabled = false;
      });
    }
  }
});

// Save gift note functionality
document.addEventListener('click', function(e) {
  if (e.target && e.target.id === 'save-gift-note-btn') {
    e.preventDefault();
    var noteField = document.getElementById('gift-note');
    if (noteField) {
      var noteValue = noteField.value;
      // Extract the attribute name, e.g., 'Gift note' from 'attributes[Gift note]'
      var attrNameMatch = noteField.name.match(/attributes\[(.*?)\]/);
      var attrName = attrNameMatch ? attrNameMatch[1] : 'Gift note';
      var btn = e.target;
      var originalText = btn.textContent;
      btn.textContent = 'Saving...';
      btn.disabled = true;

      var bodyData = { attributes: {} };
      bodyData.attributes[attrName] = noteValue;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(bodyData)
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        btn.textContent = 'Saved';
        btn.disabled = false;
        setTimeout(function() {
          btn.textContent = originalText;
        }, 2000);
      })
      .catch(function(error) {
        console.error('Error saving gift note:', error);
        btn.textContent = originalText;
        btn.disabled = false;
      });
    }
  }
});
